export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/06fef1787f03bb9657854f71ca02ea6c.jpg"
          alt="Technology Network Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="mb-4">
              <span className="text-teal-300 text-sm font-semibold uppercase tracking-wider">Welcome to</span>
              <h2 className="text-2xl font-bold text-white mt-1">Central Technology Group</h2>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
              Connecting Technology Vendors with <span className="italic font-serif text-teal-300">Global Markets</span>
            </h1>
            <p className="text-lg text-gray-200 mb-8 leading-relaxed">
              We bridge the gap between innovative technology vendors and emerging markets, providing comprehensive marketing solutions and strategic partnerships that drive growth and success.
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollToSection('partnerships')}
                className="px-8 py-3 bg-gradient-to-r from-teal-500 to-emerald-500 text-white font-medium rounded-full hover:shadow-xl transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                Explore Partnerships
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="px-8 py-3 border-2 border-teal-400 text-white font-medium rounded-full hover:bg-teal-400/10 transition-all cursor-pointer whitespace-nowrap"
              >
                View Services
              </button>
            </div>
          </div>

          <div className="relative hidden md:block">
            <div className="relative bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              <div className="w-full h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=Isometric%203D%20illustration%20of%20technology%20ecosystem%20with%20interconnected%20devices%20and%20data%20flow%2C%20modern%20business%20network%20visualization%20with%20floating%20elements%2C%20clean%20minimal%20design%20with%20teal%20and%20emerald%20accent%20colors%2C%20professional%20tech%20illustration%20showing%20global%20connectivity%20and%20digital%20transformation&width=600&height=600&seq=hero-illustration-001&orientation=squarish"
                  alt="Technology Network Illustration"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl p-4">
                <div className="text-2xl font-bold text-teal-600">95%</div>
                <div className="text-xs text-gray-600">Success Rate</div>
              </div>
              <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl shadow-xl p-4">
                <div className="text-2xl font-bold text-emerald-600">150+</div>
                <div className="text-xs text-gray-600">Market Entries</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}